<template>
    <div class="row">
        <div class="col-12">
            <div class="alert alert-secondary">
                <div class="alert-text">Workdays </div>
            </div>
        </div>
        <div class="workdays col-6 offset-3">

            <button type="button"
                        class="btn btn-sm btn-info"
                        @click.stop.prevent="addNewWorkDay"
                        v-if="workDays.length < 7">
                    {{$t('UI.addWorkDay')}}
            </button>
            <div v-if="workDays">
                <div class="workday row" v-for="(workDay, workDayIndex) in workDays"
                    :key="workDay.day">
                    <div class="col-12">
                        <div class="btn-group-text">
                            <h5 class="group-text">{{isoDay(workDay.day)}}</h5>
                            <div class="btn-group">
                                <button class="btn btn-sm btn-primary"
                                        @click.stop.prevent="addNewWorkHour(workDayIndex)">
                                    {{$t('REGISTRATION.addWorkHours')}}
                                </button>
                                <button class="btn btn-sm btn-danger"
                                        @click.stop.prevent="removeWorkDay(workDayIndex)">
                                    {{$t('REGISTRATION.removeWorkDay')}}
                                </button>
                            </div>
                        </div>
                        <div class="row" v-for="(workHour, workHourIndex) in workDay.workHours"
                            :key="workHourIndex">
                            <form-input :normal="false"
                                        :showPlaceholder="false"
                                        :elementID="workDayIndex + '-' + workHourIndex + 'start'"
                                        inputClass="form-control-sm"
                                        inputType="text"
                                        :validator="$v.workDays.$each[workDayIndex].workHours.$each[workHourIndex].start"
                                        v-model="workHour.start"/>
                            <form-input :normal="false"
                                        :elementID="workDayIndex + '-' + workHourIndex + 'end'"
                                        :showPlaceholder="false"
                                        inputClass="form-control-sm"
                                        inputType="text"
                                        :validator="$v.workDays.$each[workDayIndex].workHours.$each[workHourIndex].end"
                                        v-model="workHour.end"
                                        :show-remove="true"
                                        @remove="removeWorkHour(workDayIndex, workHourIndex)"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import FormInput from '../../../../Shared/UI/Form/FormInput.vue';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'shop-workdays-data',
    components: { FormInput },
    props: {
        data: {
            type: Array,
            default(){
              return [];
            }
        }
    },
    computed: {
        workDays: {
            get(){
                return this.data;
            },
            set(newValue){
                this.$emit('update:data', newValue);
            }
        }
    },
    methods: {
        isoDay (day) {
            return moment(moment().day(+day)).format('dddd');
        },
        addNewWorkDay () {
          if(this.workDays){
            let missingDay = 0;
            let missingDayFound = false;
            for(let i = 0; i <= this.workDays.length; i++) {
                if(this.workDays[i] && +this.workDays[i].day === i + 1) {
                    continue;
                } else {
                    missingDay = i + 1;
                    missingDayFound = true;
                    break;
                }
            }
            if(missingDayFound) {
                this.workDays.splice(missingDay - 1, 0, {
                    day: missingDay,
                    workHours: []
                });
            } else {
                this.workDays.push({
                    day: this.workDays.length + 1,
                    workHours: []
                });
            }
          }
        },
        addNewWorkHour (workDayIndex) {
            this.workDays[workDayIndex].workHours.push({
                start: '08:00',
                end: '20:30'
            });
        },
        removeWorkHour (workDayIndex, workHourIndex) {
            this.workDays[workDayIndex].workHours.splice(workHourIndex, 1);
        },
        removeWorkDay (workDayIndex) {
            this.workDays.splice(workDayIndex, 1);
        },
    },
    validations: {
        workDays:  {
            $each: {
                workHours: {
                    $each: {
                        start: {
                            required
                        },
                        end: {
                            required
                        }
                    }
                }
            }
        }
    },
    beforeMount(){
        this.workDays = this.data;
    }
};
</script>

<style lang="scss">
    //.workdays{
        .workday{
            &:nth-child(odd){
                .content{
                    background-color: #ebedf2;
                }
            }
        }
    //}
    .btn-group-text{
        display: flex;
        display: -webkit-box;
        display: -ms-flexbox;
        border-bottom: 1px solid #ebedf2;
        padding: 5px 0;
        position: relative;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        .group-text, .btn-group{
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }
        .group-text{
            -ms-flex-line-pack: flex-first;
            align-content: flex-first;
            margin-bottom: 0;
            color: #3d4465;
            font-size: 1.3em;
        }
        .btn-group{
            button{
                font-size: 1em;
            }
            -ms-flex-line-pack: end;
            align-content: flex-end;
        }
    }
</style>
